import { render, staticRenderFns } from "./CallSync.vue?vue&type=template&id=21429582"
import script from "./CallSync.vue?vue&type=script&lang=js"
export * from "./CallSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports